<template>
  <section>
    <div class="container is-fluid">
      <div class="columns is-multiline">
        <div
          class="column is-one-third"
          v-for="document in $store.state.property.documents"
          :key="document.id"
        >
          <div class="card moveable-card">

            <div class="card-content">

              <div class="level is-marginless">
                <div class="has-text-weight-semibold">
                  {{ document.name }}
                </div>
                <div class="level-right">
                  <i
                    class="far fa-2x"
                    :class="getFontAwesomeIconFromMIME(document.contentType)"
                    style="padding-left: 10px"
                  ></i>
                </div>
              </div>

              <div class="level">
                <div class="level-left">
                  <span>
                    <div class="is-size-7">{{ document.createdUtc | dateMedium }}</div>
                    <div class="is-size-7">{{ document.createdUtc | fromNow }}</div>
                  </span>
                </div>

                <div class="level-right">
                  <span>
                    <b-icon
                      :pack="stageStyle(document.stage)"
                      v-bind:icon="stageStyle(document.stage)"
                      size="is-small"
                    ></b-icon>
                    <span class="is-size-7">{{ document.stage }}</span>
                    <div class="is-size-7">{{ document.size | mb }}</div>
                  </span>
                </div>
              </div>

              <div class="level-left">

                <div class="level-item">
                  <span class="link">
                    <b-tooltip
                      label="Edit"
                      position="is-bottom"
                    >
                      <a
                        class="fas fa-edit"
                        @click="editDocument(document)"
                      ></a>
                    </b-tooltip>
                  </span>
                </div>

                <div class="level-item">
                  <b-tooltip
                    label="Download"
                    position="is-bottom"
                  >
                    <a
                      :href="document.url"
                      target="_blank"
                    >
                      <i class="fas fa-download"></i>
                    </a>
                  </b-tooltip>
                </div>

                <div class="level-item">
                  <span class="icon">
                    <b-tooltip
                      label="Delete"
                      position="is-bottom"
                    >
                      <a
                        class="fas fa-trash"
                        @click="deleteDocument(document)"
                      ></a>
                    </b-tooltip>
                  </span>
                </div>

              </div>

            </div>

          </div>
        </div>
      </div>
    </div>

    <b-modal
      :active.sync="isEditDocumentActive"
      has-modal-card
      :canCancel="[]"
    >
      <EditDocument
        v-bind:document="
      document"
        v-bind:propertyId="$store.state.property.id"
      >
      </EditDocument>
    </b-modal>

  </section>

</template>

<script>
import EditDocument from "@/components/properties/documents/EditDocument.vue";
import Helpers from "@/services/Helpers.js";
import LiberatorService from "@/services/LiberatorService.js";

export default {
  components: {
    EditDocument,
    Helpers,
    LiberatorService
  },

  props: { propertyId: String },

  data() {
    return {
      document: "",
      isEditDocumentActive: false
    };
  },

  computed: {
    downloadUrl: function() {
      return "http://www.google.com";
    }
  },

  methods: {
    stageStyle(stage) {
      return Helpers.getStageStyle(stage);
    },

    editDocument(document) {
      this.document = document;
      this.isEditDocumentActive = true;
    },

    deleteDocument(document) {
      this.$buefy.dialog.confirm({
        title: "Deleting document",
        message: `<b>Delete this document?</b><br><br>${
          document.name
        }<br><br>This cannot be undone.`,
        confirmText: "Delete Document",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => {
          var propertyId = this.$store.state.property.id;
          var documentId = document.id;
          this.$store.dispatch("deleteDocument", {
            propertyId,
            documentId
          });
          this.$buefy.toast.open({
            message: "Document deleted",
            type: "is-success",
            duration: 3000
          });
        }
      });
    },

    getFontAwesomeIconFromMIME(mimeType) {
      return Helpers.getFontAwesomeIconFromMIME(mimeType);
    }
  }
};
</script>

<style>
</style>
